<echarts [initOpts]="initOpts" [options]="options"></echarts>